import React from 'react'
import { useDarkMode } from '../../context/DarkModeContext';
import { Button, Space } from 'antd';
import { Monitor, Moon, Sun } from 'lucide-react';

const ThemeSettings = () => {
    const { theme, setThemeMode } = useDarkMode();

    return (
        <div className="Theme-Settings mt-6">
            <Space wrap>
                <Button
                    icon={<Sun size={18} />}
                    size="large"
                    variant={theme === 'light' ? "solid" : 'filled'}
                    color="default"
                    onClick={() => setThemeMode("light")}
                >
                    Light
                </Button>

                <Button
                    icon={<Moon size={18} />}
                    size="large"
                    variant={theme === 'dark' ? "solid" : 'filled'}
                    color="default"
                    onClick={() => setThemeMode("dark")}
                >
                    Dark
                </Button>

                <Button
                    icon={<Monitor size={18} />}
                    size="large"
                    variant={theme === 'system' ? "solid" : 'filled'}
                    color="default"
                    onClick={() => setThemeMode("system")}
                >
                    Device
                </Button>
            </Space>
        </div>
    )
}

export default ThemeSettings